import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

import { getCustomErrorMessage } from '../publication/helper';

interface BulkReplaceStageRequestPayload {
  display_name: string;
  from_component_id: number;
  to_component_id: number;
  assembly_id: number[];
}

export const useBulkReplaceStageAssemblyComponents = () => {
  return useMutation({
    mutationFn: saveBulkReplaceStageRequest,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequestNamesByAssemblyIds.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequests.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
    },
  });
};

const saveBulkReplaceStageRequest = async (
  payload: BulkReplaceStageRequestPayload,
) => {
  const response = await requestCCApi(
    {
      url: `/bulkReplaceRequests`,
      method: 'POST',
      data: { data: payload },
    },
    true,
    getCustomErrorMessage,
  );

  return [response.data];
};
